module.exports = __webpack_public_path__ + "img/undraw_Website_builder_re_ii6e.231ec1c5.svg";